import OrderAppLib from 'dimorder-orderapp-lib';

// Helper function to create locale helper for an order
function createOrderLocaleHelper(symbolName) {
  return OrderAppLib.libs.createLocaleHelper({
    getCountryFromStore() {
      return symbolName;
    },
  });
}

export function currencyWithCommas(num, symbolName, rounding) {
  if (num === undefined || num === null) {
    num = 0;
  }

  return createOrderLocaleHelper(symbolName).formatCurrency(num, { minimumFractionDigits: rounding?.minFractionDigits ?? 0 });
}

export default {
  currencyWithCommas,
};
